import React, { useEffect, useState } from "react";
import style from "./style.module.scss";

interface Checkbox {
  options: { label: string; value: string }[];
  defaultChecked: string;
  onChange: (value: any) => void;
}

const FormCheckboxGroup: React.FC<Checkbox> = ({
  options,
  defaultChecked,
  onChange,
}) => {
  const [checkedValues, setCheckedValues] = useState<string[]>([]);

  useEffect(() => {
    if (defaultChecked) {
      setCheckedValues([defaultChecked]);
    }
  }, [defaultChecked]);

  useEffect(() => {
    if (checkedValues.length) {
      onChange(checkedValues);
    }
  }, [checkedValues]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setCheckedValues((prevValues) =>
      checked
        ? [...prevValues, value]
        : prevValues.filter((checkedValue) => checkedValue !== value)
    );
  };

  return (
    <div className={style.parent}>
      {options.map(({ label, value }) => (
        <div key={value} className={style.child}>
          <input
            type="checkbox"
            value={value}
            className={style.input}
            onChange={handleChange}
            checked={checkedValues.includes(value)}
            id={value} // ✅ also fix label connection
          />
          <label htmlFor={value} className={style.label}>
            {label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default FormCheckboxGroup;
